import angular from 'angular'
import template from './template.html'

angular.module('nominas.pendientes')
  .component('nominasPendientesCotizarProyecto', {
    template: template,
    controller: Component,
    bindings: {
      idEmpresa: '<',
      empresa: '<',
    },
  });

function Component($http, $location, $scope) {
  let $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.seleccionar = seleccionar;

  function $onInit() {
    $ctrl.idNomina = $location.search().id_nomina || null;

    $scope.$on('$locationChangeSuccess', function () {
      $ctrl.idNomina = $location.search().id_nomina || null;
    });

    $ctrl.$promise = $http.get('/api/nominas/pendientes/cotizar/proyecto', {
        params: {id_empresa: $ctrl.idEmpresa},
        schema: {
          maquilado_fecha: 'timestamp',
          status_cotizado: 'boolean',
          status_aprobado: 'boolean',
        },
      })
      .then(function ($resolve) {
        $ctrl.data = $resolve.data;
      });
  }

  function seleccionar(id_empresa, id_nomina) {
    $location.search({id_empresa: id_empresa, id_nomina: id_nomina});
  }
}



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/cotizar/proyecto/component.js